export default __webpack_public_path__ + "static/media/oumayma.c672d60c.png";